import { put, takeLatest } from "redux-saga/effects";
import {
  GET_MEETING_DETAILS_INIT,
  GET_MEETING_DETAILS_SUCCESS,
  GET_MEETING_DETAILS_FAILED,
  GET_MEETING_DETAILS,
  UPDATE_STATUS_ATTENDEE,
  UPDATE_STATUS_ATTENDEE_INIT,
  UPDATE_STATUS_ATTENDEE_SUCCESS,
  UPDATE_STATUS_ATTENDEE_FAILED,
  UPDATE_GOOGLE_CALENDAR_MEETING,
  UPDATE_GOOGLE_CALENDAR_MEETING_INIT,
  UPDATE_OUTLOOK_CALENDAR_MEETING_INIT,
  UPDATE_OUTLOOK_CALENDAR_MEETING,
  GET_MONTHLY_MEETING_SUCCESS,
  GET_MONTHLY_MEETING_INIT,
  GET_MONTHLY_MEETING_FAILED,
  GET_MONTHLY_MEETING
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import { gapi } from "gapi-script";
import { Client }  from "@microsoft/microsoft-graph-client";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { AuthCodeMSALBrowserAuthenticationProvider} from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";


export function* getMeetingDetail({ appointmentId }) {
  yield put({ type: GET_MEETING_DETAILS_INIT });
  try {
    const res = yield getUtil(
      `${API.GetMeetingDetails}?appointmentId=${appointmentId}`
    );

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_MEETING_DETAILS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_MEETING_DETAILS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getMonthlyMeeting({ month,year }) {
  yield put({ type: GET_MONTHLY_MEETING_INIT });
  console.log('in this function');
  try {
    const res = yield getUtil(
      `${API.GetMonthlyMeetings}?month=${month}&year=${year}`
    );
    if (res?.status === 200) {
      const { data } = res;
      console.log('response data ', res);

      console.log(' data ', data);
      yield put({ type: GET_MONTHLY_MEETING_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_MONTHLY_MEETING_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateStatusAppointmentAttendee({payload , onSuccess}) {
  yield put({ type: UPDATE_STATUS_ATTENDEE_INIT });
  try {
    const res = yield postUtil(API.UpdateAttendeeStatus, payload);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_STATUS_ATTENDEE_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_STATUS_ATTENDEE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateGoogleCalendarMeeting({ payload, onSuccessAlert }) {
  yield put({ type: UPDATE_GOOGLE_CALENDAR_MEETING_INIT });
  try {
    window.gapi.load('client:auth2', () => {

      window.gapi.client.init({
        apiKey: window._env_.API_KEY,
        clientId: window._env_.CLIENT_ID,
        // discoveryDocs: window._env_.DISCOVERY_DOC,
        scope: window._env_.SCOPES,
      })
  
      window.gapi.client.load('calendar', 'v3')

      window.gapi.auth2.getAuthInstance().signIn()
        .then(() => {

          var request = window.gapi.client.calendar?.events.insert({
            'calendarId': 'primary',
            'resource': payload,
          })
          request.execute(event => {
            if (event.id != '') {
              onSuccessAlert();
            }
            window.open(event.htmlLink)
          })
        })
    })
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateOutlookCalendarMeeting({ payload, onSuccessAlert }) {
  yield put({ type: UPDATE_OUTLOOK_CALENDAR_MEETING_INIT });
  try {
    const clientId = window._env_.OUTLOOK_CLIENT_ID;

    const config = {
      auth: {
        clientId: clientId,
        redirectUri: window._env_.OUTLOOK_REDIRECT_URL, 
      },
    };
    
    const loginRequest = {
      scopes: window._env_.OUTLOOK_SCOPES,
    };
        
    const myMsal = new PublicClientApplication(config);

    myMsal
      .loginPopup(loginRequest)
      .then(async function (loginResponse) {

        let accountId = loginResponse.account.homeAccountId;
        if (accountId != "") {
          const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(myMsal,
            {
              account: loginResponse,
              scopes: loginRequest.scopes,
              interactionType: InteractionType.Popup
            }
          );

          const client = Client.initWithMiddleware({
            debugLogging: true,
            authProvider
          });

          await client.api(`/me/calendar/events`)
            .post(payload)
            .then((res) => {
              onSuccessAlert();
              window.open(res.webLink);
            });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (error) {
    throw new Error(error);
  }
}


export function* meetingDetails() {
  yield takeLatest(GET_MEETING_DETAILS, getMeetingDetail);
  yield takeLatest(UPDATE_STATUS_ATTENDEE, updateStatusAppointmentAttendee);
  yield takeLatest(UPDATE_GOOGLE_CALENDAR_MEETING, updateGoogleCalendarMeeting);
  yield takeLatest(UPDATE_OUTLOOK_CALENDAR_MEETING, updateOutlookCalendarMeeting);
  yield takeLatest(GET_MONTHLY_MEETING, getMonthlyMeeting)
}
